/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SetupAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SetupAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/ApptTypes/SetupAction",
  disabled,
  onSubmit
  
}) {
let dataSubmitData = fromData.useDataSubmit({ viewPath,
context: 'data',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 data="data"
 disabled={disabled}
 onClick={dataSubmitData}
 text="Setup appt types"
/>
{children}
</React.Fragment>)
}